import BoxLoading from '#/components/box-loading'

export default function PageLoading() {
  return (
    <div className="w-full h-full grid place-content-center">
      <BoxLoading />
    </div>
  )
}
